import React from 'react';
import esriStrings from '../../resources/esriStrings';
import Social from '../header/social';
import CtaButton from '../bitsnbobs/ctaButton';
import './ctaFooter.scss';

const CtaFooter = (props) =>
  <div className="cta-footer">
    <div className="cta-footer-section cta-footer-social">
      <Social></Social>
    </div>
    <div className="cta-footer-section cta-footer-button">

      <CtaButton formVisible = {props.formVisible} showForm = {props.showForm}></CtaButton>
    </div>
  </div>
;

export default CtaFooter;
